import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faCalendarAlt, faClock, faGlobe, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import './BookingError.css';

interface BookingErrorProps {
    errorMessage: string;
    selectedTime?: string;
    eventTitle?: string;
    timeZone?: string;
    onBack: () => void;
}

const BookingError: React.FC<BookingErrorProps> = ({ 
    errorMessage, 
    selectedTime, 
    eventTitle, 
    timeZone, 
    onBack 
}) => {
    return (
        <div className="booking-error">
            <div className="error-icon">
                <FontAwesomeIcon icon={faExclamationTriangle} />
            </div>
            
            <h2 className="error-title">Booking Failed</h2>
            
            <p className="error-message">
                {errorMessage}
            </p>
            
            {(eventTitle || selectedTime) && (
                <div className="error-details">
                    {eventTitle && (
                        <div className="error-event-name">
                            <FontAwesomeIcon icon={faCalendarAlt} className="icon-left" />
                            {eventTitle}
                        </div>
                    )}
                    
                    {selectedTime && (
                        <div className="error-time">
                            <FontAwesomeIcon icon={faClock} className="icon-left" />
                            {selectedTime}
                        </div>
                    )}
                    
                    {timeZone && (
                        <div className="error-timezone">
                            <FontAwesomeIcon icon={faGlobe} className="icon-left" />
                            All times shown in {timeZone}
                        </div>
                    )}
                </div>
            )}
            
            <div className="error-buttons">
                <button
                    onClick={onBack}
                    className="error-back-button"
                >
                    <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
                    Back to Calendar
                </button>
                
                <button
                    onClick={onBack}
                    className="error-retry-button"
                >
                    Try Again
                </button>
            </div>
        </div>
    );
};

export default BookingError; 